<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p style="text-align: center;">Alan Dawson, Dorothy, John Bell, Martin Blacker, Ray Jones, Cynthia, Albert Smith family Collector’s Gazette.</p>
<p style="text-align: center;">Appleby home front.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?57faa0f9